import theme, { actionButtonSx } from '@/theme'

import ChargingPointScreenTemplate from './template/ChargingPointScreenTemplate'
import { ChargingPointScreenProps } from './types'

import { Button } from '@mui/material'

import ChargingSessionBody from '../components/ChargingSessionBody'

const ConnectedChargingPointScreen: React.FC<ChargingPointScreenProps> = (props) => {
  const handleOnClickStartCharging = () => {
    props.onStartCharging?.()
  }

  return (
    <ChargingPointScreenTemplate
      {...props}
      Body={
        <ChargingSessionBody
          message={
            <>
              Cabo <b style={{ color: theme.palette.success.main }}>conectado</b>.
              <br />
              Pressione iniciar para começar o carregamento.
            </>
          }
        />
      }
      Footer={
        <Button
          variant="contained"
          color="primary"
          disableElevation
          fullWidth
          loading={props.isStartingCharging}
          onClick={handleOnClickStartCharging}
          sx={actionButtonSx}
        >
          Iniciar carregamento
        </Button>
      }
    />
  )
}

export default ConnectedChargingPointScreen
